import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import VueI18n from 'vue-i18n'
import theme from './theme.js'
import { messages } from './i18n.js'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(VueI18n)
Vue.use(Vuetify)

let appLanguage = 'en'
if (navigator.language.substring(0, 2) === 'fr') {
  appLanguage = 'fr'
} else if (navigator.language.substring(0, 2) === 'es') {
  appLanguage = 'es'
}

const i18n = new VueI18n({
  locale: appLanguage,
  fallbackLocale: 'en',
  messages,
})

const options = {
  lang: { t: (key, ...params) => i18n.t(key, params) },
  icons: { iconfont: 'mdi' },
  theme: theme,
}

export default new Vuetify(options)
